export const SETTINGS_PATH = {
  myOnboardTemplate: 'onboard-template',
  manageEntities: 'manage-entities',
  accounts: 'accounts',
  users: 'users',
  equipments: 'equipments',
  tags: 'tags',
  accountSettings: 'account-settings',
};
